export default {
  'footer.copyright': '© 2024–2026 清水啓太郎 - All rights reserved',
};
